export function isGraphQLType<T extends string[]>(...typenames: T) {
  return function predicate<N extends { __typename?: string }>(
    n: N | null | undefined
  ): n is N & { __typename: T[number] } {
    return typenames.some((typename) => typename == n?.__typename)
  }
}

export function maybeGraphQLType<TNames extends string[]>(
  ...typenames: TNames
): <T extends { __typename?: string }>(
  v: T | null | undefined
) => (T & { __typename: TNames[number] }) | null {
  return (v) => {
    if (isGraphQLType(...typenames)(v)) return v
    return null
  }
}

interface Edge<T> {
  node: T | null
}

type HasNode<E extends Edge<unknown>> =
  E extends Edge<infer T> ? E & { node: T } : never

export function nonNullEdge<E extends Edge<unknown>>(
  edge: E | null
): edge is HasNode<E> {
  if (edge == null || edge.node == null) return false
  return true
}
